import { Badge, type BadgeProps } from "@atlas/core";
import { resolveHubPackageDeploymentStatusBadge } from "@utils";
import type { ReactElement } from "react";

export function getHubPackageDeploymentStatusBadge(
  status: string,
  badgeProps?: Omit<BadgeProps, "children" | "variant">,
): ReactElement | null {
  if (!status) return null;

  const badge = resolveHubPackageDeploymentStatusBadge(status);

  return (
    <Badge
      variant={badge.variant}
      className="capitalize flex items-center gap-1 w-fit"
      {...badgeProps}>
      <badge.icon className="size-3" />
      {badge.label}
    </Badge>
  );
}
